import * as React from 'react';
import { questionErrorMessage } from '../../../../../../constants/applicationMessage';
import Arrow from '../../../../../common/designElements/Arrows';

interface IncidenceRateProps {
    isRequested?: boolean;
    incidenceRate?: string;
    onBack?: () => void;
    onClose: () => void;
    updatePrice?: (data: any) => Promise<any>;
    // currentProject: Project;
    // onClose: () => void;
    // changePath: (path: string) => void;
}

const IncidenceRate: React.FunctionComponent<IncidenceRateProps> = (
    props: IncidenceRateProps
) => {
    const [isRequested, setIsRequested] = React.useState(props.isRequested);
    const [incidenceRate, setIncidenceRate] = React.useState(
        props.incidenceRate || null
    );
    const [showError, setShowError] = React.useState(false);

    const onChangeIncidenceRate = (evt) => {
        setShowError(false);
        setIncidenceRate(evt.target.value);
    };

    const onSubmit = async () => {
        setShowError(false);
        if (!incidenceRate) {
            setShowError(true);
            return;
        }
        await props.updatePrice({ incidenceRate });
        setIsRequested(true);
    };
    const onClose = async () => {
        props.onClose();
    };
    if (isRequested) {
        return (
            <React.Fragment>
                <p className="price--modal--title">Pricing has been updated</p>
                <p className="price--modal--subtitle">
                    You will be able to find the updated estimate pricing on the
                    pricing tab.
                </p>
                <div className="price--modal--footer">
                    <button
                        data-test="okay-incidence-btn"
                        className="btn btn--md btn--green"
                        onClick={onClose}
                    >
                        Okay
                    </button>
                </div>
            </React.Fragment>
        );
    }
    return (
        <React.Fragment>
            <span className="price--modal--header-back" onClick={props.onBack}>
                <Arrow type="left" /> Back
            </span>
            <p className="price--modal--title">Incidence Rate</p>
            <p className="price--modal--subtitle">
                Enter the incidence rate below, and we will provide you with an
                estimate pricing for your project.
            </p>
            <input
                className={`price--modal--incidence--input ${
                    showError ? 'error' : ''
                }`}
                type="number"
                placeholder="Incidence Rate"
                data-test="incidence-rate-input"
                min={1}
                max={100}
                onChange={(e) => onChangeIncidenceRate(e)}
                value={incidenceRate}
            />{' '}
            %
            {showError && (
                <p className="price--modal--incidence--input--msg">
                    {questionErrorMessage.REQUIRED}
                </p>
            )}
            <p className="price--modal--incidence--footer">
                Disclaimer: If the provided incidence rate is inaccurate, we
                cannot guarantee the estimated cost.{' '}
            </p>
            <div className="price--modal--footer">
                <button
                    data-test="submit-incidence-rate"
                    className="btn btn--md btn--green"
                    onClick={onSubmit}
                >
                    Submit and calculate
                </button>
            </div>
        </React.Fragment>
    );
};

export default IncidenceRate;
